import { Route, Routes } from 'react-router-dom';
import { LoginPageDevise } from './Pages';
import { MaintenancePage } from './Pages/Maintenance';
import { AuthenticatePage } from './Pages/AuthenticatePage/AuthenticatePage';
import { ResetPasswordPage } from './Pages/ResetPassword/ResetPasswordPage';
import { MfaPage } from './Pages/Mfa/MfaPage';
import { ReportPage } from './Pages/Report';
import { AdviseSharedEngagementPage } from './Pages/Advise';

export default function PublicAppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={<LoginPageDevise />}
      />
      <Route
        path="/report"
        element={<ReportPage />}
      />
      {/* Ungated: flags arrive over the socket after first render, and the API answers 404 while advise is off. */}
      <Route
        path="/advise/shared"
        element={<AdviseSharedEngagementPage />}
      />
      <Route
        path={'/portal/offline'}
        element={<MaintenancePage />}
      />
      <Route
        path={'/reset'}
        element={<ResetPasswordPage />}
      />
      <Route
        path={'/welcome'}
        element={<LoginPageDevise />}
      />
      <Route
        path={'/authenticate-user'}
        element={<AuthenticatePage />}
      />
      <Route
        path={'/mfa'}
        element={<MfaPage />}
      />
      <Route
        path="*"
        element={null}
      />
    </Routes>
  );
}
